export default "__VITE_ASSET__C3zto6Ii__"